import { useCallback, useState } from 'react';
import classnames from 'classnames';

import CardEditButton from '../../../components/card-edit-button/card-edit-button';
import styles from '../redeem-gift-card.module.scss';
import Input from '../../../components/input/input';
import Divider from '../../../components/divider/divider';
import Button from '../../../components/button/button';
import Card from '../../../components/card/card';
import { GiftCardProductDetails } from '../types';

type Props = {
    currentStep: number;
    loading: boolean;
    details?: GiftCardProductDetails;
    onVerify: (code: string) => void;
    onContinue: (code: string) => void;
    onClear: () => void;
    onEdit: (step: number) => void;
};

const VerifyGiftCardCard = ({
    currentStep,
    loading,
    details,
    onVerify,
    onContinue,
    onClear,
    onEdit,
}: Props) => {
    const [code, setCode] = useState('');

    const handleVerification = useCallback(() => {
        if (!code) return;
        onVerify(code);
    }, [code]);

    const handleContinue = useCallback(() => {
        if (!code) return;
        onContinue(code);
    }, [code]);

    return (
        <Card
            className={classnames({
                [styles.overshadowed]: currentStep !== 1,
                [styles.card]: true,
                [styles.giftCardCard]: true,
                [styles.shown]: true,
            })}
        >
            <CardEditButton shown={currentStep > 1} onClick={() => onEdit(1)} />
            <header>
                <h4>Canje de Gift Card</h4>
                <span className={styles.content}>
                    Introduce tu código aquí:
                </span>
            </header>
            <Input placeholder="Código" disabled={loading} onInput={setCode} />
            {!!details && (
                <section className={styles.productDetails}>
                    <span>
                        <b>Nombre:&nbsp;</b>
                        {details?.name}
                    </span>
                    <span>
                        <b>Descripción:&nbsp;</b>
                        {details?.description}
                    </span>
                    <span>
                        <b>Periodo:&nbsp;</b>
                        {details?.frequency}
                    </span>
                    <Divider mode="h" />
                </section>
            )}
            {!details && (
                <Button
                    text={loading ? 'Cargando...' : 'Verificar'}
                    disabled={loading}
                    onClick={handleVerification}
                />
            )}
            {!!details && (
                <div className={styles.actions}>
                    <Button
                        text="Canjear"
                        disabled={loading}
                        onClick={handleContinue}
                    />
                    <button
                        disabled={loading}
                        className={styles.discard}
                        onClick={onClear}
                    >
                        Descartar
                    </button>
                </div>
            )}
        </Card>
    );
};

export default VerifyGiftCardCard;
